import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ContextWrapper from 'components/templates/Wrappers/Sidebars/ContextWrapper/ContextWrapper';

const StyledCollectionEntitySideBarWrapper = styled(ContextWrapper)`
  .EntitiesList {
    .DataList-list {
      overscroll-behavior: contain;
    }
  }
  ${ComponentStyles}
`;

StyledCollectionEntitySideBarWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionEntitySideBarWrapper;
